require('./tabbedBox.scss');

const PropTypes = require('prop-types');

const React = require('react');
const classNames = require('classnames');
const TabbedBoxLabel = require('./tabbedBoxLabel/tabbedBoxLabel');
const TabbedBoxContent = require('./tabbedBoxContent/tabbedBoxContent');

class TabbedBox extends React.Component {

    constructor(props) {
        super(props);
        const { activeTab, onTabSelection } = this.props;
        this.state = {
            activeTab: activeTab || 0,
            controlByProps: !!onTabSelection
        };
    }

    componentDidMount() {
        const tabEl = document.querySelector('#btnNavTabbedBox'+this.props.id+ this.getActiveTab());
        const hrEl = document.querySelector('.tabbed-box__animated-underline');

        if (!!tabEl && !!hrEl) {
            hrEl.style.marginLeft = tabEl.offsetLeft + 'px';
            hrEl.style.width = tabEl.offsetWidth + 'px';
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tabs.length <= this.state.activeTab) {
            this.setState({
                activeTab: 0
            });
        }
    }

    getActiveTab = () => {
        const { controlByProps, activeTab } = this.state;
        return controlByProps ? this.props.activeTab : activeTab;
    }

    activeTab = (tab) => {
        return this.getActiveTab() === tab;
    }

    buildTabContent = (tabs) => {
        return tabs.map((tab, index) => {
            return (
                <TabbedBoxContent
                    key={index}
                    visible={this.activeTab(index)}
                >
                    {tab.content}
                </TabbedBoxContent>
            );
        });
    }

    renderTabLabels = (animated, tabs, id) => {
        if (animated) {
            return this.renderAnimatedTabLabels(tabs, id)
        } else {
            return this.renderNoAnimatedLabels(tabs, id)
        }
    }

    renderAnimatedTabLabels = (tabs, id) => {
        return tabs.map((tab, index) => {
            const tabId = `btnNavTabbedBox${id}${index}`;
            return (
                <TabbedBoxLabel
                    animated={true}
                    key={index}
                    index={index}
                    isResponsive={this.props.isResponsive}
                    label={tab.label}
                    active={this.activeTab(index)}
                    onTabSelection={this.handleSelectedTab}
                    id={tabId}
                    tabsSize={tabs.length}
                />
            );
        });
    }

    renderNoAnimatedLabels = (tabs, id) => {
        return tabs.map((tab, index) => {
            const tabId = `btnNavTabbedBox${id}${index}`;
            return (
                <TabbedBoxLabel
                    animated={false}
                    key={index}
                    index={index}
                    isResponsive={this.props.isResponsive}
                    label={tab.label}
                    active={this.activeTab(index)}
                    onTabSelection={this.handleSelectedTab}
                    id={tabId}
                    tabsSize={tabs.length}
                />
            );
        });
    }

    handleSelectedTab = (tabIndex) => {
        if (this.state.controlByProps) {
            this.props.onTabSelection(tabIndex)
        } else {
            this.setState({ activeTab: tabIndex });
        }
    }

    checkKey = (key, tabs) => {
        return tabs && tabs.length && tabs.find(tab => {
            return Object.keys(tab).includes(key);
        })
    }

    render() {
        const {
            animated,
            minWidth,
            width,
            tabs,
            customClassName,
            id,
            isResponsive,
            left,
            withBorder
        } = this.props;
        const className = classNames('tabbed-box', customClassName);
        const tabbedBoxClassName = classNames('tabbed-box__navbar', {
            'tabbed-box__navbar--left': left,
        })
        const ulClassNames = classNames('tabbed-box__tab-container', {
            'tabbed-box__tab-container--border': withBorder,
            'row': isResponsive,
        })
        const style = {
            style: {
                ...(animated ? {
                    width: `${width}%`,
                    minWidth: `${minWidth}px`
                } : {})
            }
        }
        const tabEl = document.querySelector('#btnNavTabbedBox'+id+ this.getActiveTab());
        let hrStyle = {};
        if (!!tabEl) {
            hrStyle.marginTop = tabEl.offsetTop;
            hrStyle.marginLeft = tabEl.offsetLeft;
            hrStyle.width = tabEl.offsetWidth;
        }
        return (
            <div className={className}>
                {
                    this.checkKey('label', tabs) &&
                        <nav className={tabbedBoxClassName} {...style} >
                            <ul className={ulClassNames}>
                                { this.renderTabLabels(animated, tabs, id) }
                            </ul>
                            {
                                animated &&
                                    <hr
                                        className="tabbed-box__animated-underline"
                                        style={hrStyle}
                                    />
                            }
                        </nav>
                }
                {
                    this.checkKey('content', tabs) &&
                        <div className="tabbed-box__container">
                            { this.buildTabContent(tabs) }
                        </div>
                }
            </div>
        );
    }
}

TabbedBox.propTypes = {
    activeTab: PropTypes.number,
    onTabSelection: PropTypes.func,
    left: PropTypes.bool,
    tabs: PropTypes.array,
    minWidth: PropTypes.number,
    customClassName: PropTypes.string,
    id: PropTypes.string,
    isResponsive: PropTypes.bool,
    width: PropTypes.number,
    withBorder: PropTypes.bool,
    animated: function(props, propName, componentName) {
        if (typeof(props[propName]) != 'boolean') {
            return new Error(
              'Invalid prop `' + propName + '` supplied to' +
              ' `' + componentName + '`. Validation failed.'
            );
        }
    },

}

TabbedBox.defaultProps = {
    animated: false,
    isResponsive: false,
    left: false,
    withBorder: true,
}

module.exports = TabbedBox;